import { defineMessages } from "react-intl";

export const sharedMessages = defineMessages({
  pdfGenerationError: {
    id: "shared.toast.pdfGenerationError",
    defaultMessage: "Failed to generate PDF. Please try again.",
  },
  forceSubmitBtnSubmitting: {
    id: "shared.button.forceSubmitSubmitting",
    defaultMessage: "Submitting...",
  },
  forceSubmitBtn: {
    id: "shared.button.forceSubmit",
    defaultMessage: "Force Submit",
  },
});
